module.exports = __webpack_public_path__ + "static/media/default_avatar.5b4c72f1.jpg";